module.exports = __webpack_public_path__ + "54358a98216f8cae82b00e4149fbdf34.woff2";